import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const CrIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 40 40" sx={{ height: '40px', width: '40px', fill: 'transparent', ...sx }} {...props}>
      <rect width="40" height="40" rx="20" fill="#FF5F57" fillOpacity="0.1" />
      <path
        d="M20 28V12M20 12L14 18M20 12L26 18"
        stroke="#FF5F57"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default CrIcon;
